module.exports = __webpack_public_path__ + "img/sale-path-green.63de32ec.png";